module.exports = __webpack_public_path__ + "static/img/restroom-icon-active.740fae61.svg";